import { render, staticRenderFns } from "./CapacityType.vue?vue&type=template&id=6b22a4be"
import script from "./CapacityType.vue?vue&type=script&lang=ts"
export * from "./CapacityType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports